/** Config EmptyShelves */
export const apiBase = "https://api.emptyshelves.com/v1/";
export const loginPageEmail = "info@myemptyshelves.com";
export const loginPageLogo = "ES/logo_login.png";
export const loginPageBanner = "ES/login_banner.png";
export const homePageLogo = "ES/logo_home.png";
export const favicon = "ES/favicon.ico";
export const documentTitle = "EMPTY SHELVES";
export const logoWidth = 150;
export const socketIOServerAdd = "https://api.emptyshelves.com/";

//** To make it available for all the users, leave forTeams=[] blank */
export const winnersMap = [
  {
    conditions: {
      module: "",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "REJECT",
      bgColor: "#F20050",
      textColor: "#FFFFFF",
      sound: "audioReject",
    },
  },
  {
    conditions: {
      module: "MARKETPLACE",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioMP",
    },
  },
  {
    conditions: {
      module: "AMAZON",
      subModule: "FBA",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioES",
    },
  },
  {
    conditions: {
      module: "AMAZON NEW",
      subModule: "FBA",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioFBANew",
    },
  },
  {
    conditions: {
      module: "AMAZON NEW",
      subModule: "MF",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES - NEW",
      bgColor: "#F4874B",
      textColor: "#FFFFFF",
      sound: "audioMFNew",
    },
  },
  {
    conditions: {
      module: "AMAZON",
      subModule: "MF",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES - NEW",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioES",
    },
  },
  {
    conditions: {
      module: "AMAZON CA",
      subModule: "FBA",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES CA",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioFBACA",
    },
  },
  {
    conditions: {
      module: "AMAZON CA",
      subModule: "MF",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES CA",
      bgColor: "#F4874B",
      textColor: "#FFFFFF",
      sound: "audioMFCA",
    },
  },
  {
    conditions: {
      module: "MARKETPLACE CA",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "MARKETPLACE CANADA",
      bgColor: "#8586D1",
      textColor: "#FFFFFF",
      sound: "audioMPCA",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "SBYB",
      forTeams: [],
      excludeTeams: [5],
    },
    display: {
      name: "SBYB",
      bgColor: "#6a8a82",
      textColor: "#FFFFFF",
      sound: "audioSBYB",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "SBYB",
      forTeams: [5],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioES",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "RMS",
      forTeams: [],
      excludeTeams: [5],
    },
    display: {
      name: "$10 Box",
      bgColor: "#fbbc04",
      textColor: "#FFFFFF",
      sound: "audioRMS",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "RMS",
      forTeams: [5],
      excludeTeams: [],
    },
    display: {
      name: "EMPTY SHELVES",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioES",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "BR",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "BOOKSRUN",
      bgColor: "#0D3C55",
      textColor: "#FFFFFF",
      sound: "audioBR",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "BRB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "BLUE ROCKET BOOKS",
      bgColor: "#212323",
      textColor: "#FFFFFF",
      sound: "audioBRB",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "SB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "SELLBOOKS",
      bgColor: "#72a2c0",
      textColor: "#FFFFFF",
      sound: "audioSB",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "ZIFFIT",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "ZIFFIT",
      bgColor: "#0444bf",
      textColor: "#FFFFFF",
      sound: "audioZIFFIT",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "UBB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "UBB",
      bgColor: "#474749",
      textColor: "#FFFFFF",
      sound: "audioUBB",
    },
  },
  {
    conditions: {
      module: "BOOKSCOUTER",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "BS: [SUB_MODULE]",
      bgColor: "#a37c27",
      textColor: "#FFFFFF",
      sound: "audioBS",
    },
  },
  {
    conditions: {
      module: "BOOKSTORE",
      subModule: "",
      forTeams: [],
      excludeTeams: [5],
    },
    display: {
      name: "[SUB_MODULE]",
      bgColor: "#6465A5",
      textColor: "#FFFFFF",
      sound: "audioWS",
    },
  },
  {
    conditions: {
      module: "BOOKSTORE",
      subModule: "",
      forTeams: [5],
      excludeTeams: [],
    },
    display: {
      name: "WHALE SALE",
      bgColor: "#6465A5",
      textColor: "#FFFFFF",
      sound: "audioWS",
    },
  },
  {
    conditions: {
      module: "HITLIST",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "[SUB_MODULE]",
      bgColor: "#040c0e",
      textColor: "#FFFFFF",
      sound: "audioHitList",
    },
  },
];
